import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { changePlanningTeam } from '../actions'
import PlanTeams from '../components/PlanTeams'
import PlanTeamMembers from '../components/PlanTeamMembers'

class PlanList extends Component {
  componentWillMount() {
    const { match, plans, changePlanningTeam } = this.props
    if(match.params.id !== plans.selectedTeamId){
      if(match.params.id){
        changePlanningTeam(match.params.id)
      } else if(plans.selectedTeamId) {
        changePlanningTeam(plans.selectedTeamId)
      } else {
        changePlanningTeam('all')
      }
    }
  }
  render() {
    const { plans } = this.props
    return (
      plans.selectedTeamId === "all" ?
        <PlanTeams />
      :
        <PlanTeamMembers />
    )
  }
}

export default connect(
  state => ({
    plans: state.plans
  }),
  { changePlanningTeam }
)(withRouter(PlanList))



// WEBPACK FOOTER //
// ./src/components/PlanList.js